var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayBackicon = function SvgPlayBackicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.25 3a.75.75 0 0 1 .75.75v6.395l10.911-6.53a1.65 1.65 0 0 1 1.677-.021c.562.319.912.937.912 1.61v13.593c0 .674-.35 1.29-.912 1.61a1.65 1.65 0 0 1-1.677-.022L6 13.855v6.395a.75.75 0 1 1-1.5 0V3.75A.75.75 0 0 1 5.25 3"
  })));
};
export default SvgPlayBackicon;